import styled from 'styled-components';
import { lightenHex } from '../utils/annotationPresentation';

export const ModalContent = styled.div`
  padding: 20px;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid ${props => props.theme.colors.greyL};
`;

export const IconCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${props => props.theme.colors.greyXXXL};
  border: 2px solid ${props => props.bg || props.theme.colors.grey};
  color: ${props => props.theme.colors.greyXXD};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-right: 15px;
`;

export const HeaderText = styled.div`
  flex: 1;
`;

export const Title = styled.h2`
  margin: 0 0 5px 0;
  font-size: 18px;
  font-weight: 600;
  color: ${props => props.theme.colors.textPrimary};
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SeverityBadge = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  background: ${(props) => {
    const s = (props.severity || '').toLowerCase();
    if (s === 'critical') return lightenHex(props.theme.colors.critical, 120);
    if (s === 'high' || s === 'warning' || s === 'poor') return lightenHex(props.theme.colors.warning, 120);
    if (s === 'medium' || s === 'fair') return lightenHex(props.theme.colors.moderate, 120);
    if (s === 'low' || s === 'good') return props.theme.colors.greenXXL;
    return props.theme.colors.greyXXXL;
  }};
  color: ${(props) => {
    const s = (props.severity || '').toLowerCase();
    if (s === 'critical') return props.theme.colors.critical;
    if (s === 'high' || s === 'warning' || s === 'poor') return props.theme.colors.warning;
    if (s === 'medium' || s === 'fair') return props.theme.colors.moderate;
    if (s === 'low' || s === 'good') return props.theme.colors.normal;
    return props.theme.colors.greyXXD;
  }};
`;

export const StateBadge = styled.span`
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  background: ${(props) => {
    const state = (props.state || '').toLowerCase();
    if (state === 'open') return lightenHex(props.theme.colors.critical, 120);
    if (state === 'closed') return lightenHex(props.theme.colors.normal, 120);
    if (state === 'acknowledged') return lightenHex(props.theme.colors.warning, 120);
    return props.theme.colors.greyXXXL;
  }};
  color: ${(props) => {
    const state = (props.state || '').toLowerCase();
    if (state === 'open') return props.theme.colors.critical;
    if (state === 'closed') return props.theme.colors.normal;
    if (state === 'acknowledged') return props.theme.colors.warning;
    return props.theme.colors.greyXXD;
  }};
`;

export const Subtitle = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colors.textSecondary};
`;

export const ContentSection = styled.div`
  margin-bottom: 20px;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 600;
  color: ${props => props.theme.colors.textPrimary};
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: 15px;
  white-space: pre-wrap;
`;

export const MetadataGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  font-size: 13px;
`;

export const MetadataItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  background: ${props => props.theme.colors.backgroundLight || '#f5f5f5'};
  border-radius: 4px;
`;

export const MetadataLabel = styled.span`
  font-weight: 500;
  color: ${props => props.theme.colors.textSecondary};
`;

export const MetadataValue = styled.span`
  color: ${props => props.theme.colors.textPrimary};
  font-weight: 500;
`;

export const AlarmSpecificSection = styled.div`
  background: ${props => props.theme.colors.backgroundLight || '#f5f5f5'};
  padding: 15px;
  border-radius: 6px;
  margin-top: 15px;
`;

export const AlarmField = styled.div`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const AlarmLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: ${props => props.theme.colors.textSecondary};
  margin-bottom: 4px;
`;

export const AlarmValue = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colors.textPrimary};
  line-height: 1.4;
`;
